import React, { useState, useEffect } from "react";
import { generateClient } from 'aws-amplify/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Messages = ({ selectedVendorForFiltering, selectedProductForFiltering, selectedOrderForFiltering, setSelectedMessageForFiltering, allMode }) => {
    const client = generateClient();
    const [messages, setMessages] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredMessages, setFilteredMessages] = useState([]);
    const [selectedMessageId, setSelectedMessageId] = useState(null);

    // Fetch messages
    async function fetchData() {
        try {
            const retrieveMessages = await client.graphql({
                query: `
               query MyQuery {
                orderMessages {
                    attachment
                    created_at
                    id
                    message
                    order_id
                    recipient
                    sender
                    updated_at
                }
                }
            `,
                authMode: 'userPool',
            });

            const sortedMessages = retrieveMessages.data.orderMessages.sort((a, b) => a.id - b.id);
            setMessages(sortedMessages);
            setFilteredMessages(sortedMessages); // Initially display all messages
        } catch (error) {
            console.error("Error fetching message data:", error);
        }
    }

    // Handle search term input
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);

        // Filter messages based on search term
        const filtered = messages.filter((message) =>
            message.sender?.toLowerCase().includes(e.target.value.toLowerCase()) ||
            message.recipient?.toLowerCase().includes(e.target.value.toLowerCase()) ||
            message.message?.toLowerCase().includes(e.target.value.toLowerCase()) ||
            message.id.toString().includes(e.target.value)
        );
        setFilteredMessages(filtered);
    };

    // Apply filtering based on vendor and product selection
    useEffect(() => {
        let filtered = messages;

        if (selectedOrderForFiltering) {
            filtered = filtered.filter((message) =>
                message.order_id && message.order_id === selectedOrderForFiltering
            );
        }

        setFilteredMessages(filtered);
    }, [selectedOrderForFiltering, messages]);

    // Fetch data when component is mounted
    useEffect(() => {
        fetchData();
    }, []);

    // Handle row click to select message
    const handleRowClick = (messageId) => {
        setSelectedMessageId(messageId);
        if (messageId === null) {
            setSelectedMessageForFiltering(null);
            setFilteredMessages(messages);
        } else {
            setSelectedMessageForFiltering(messageId);
            const filtered = messages.filter((message) => message.id === messageId);
            setFilteredMessages(filtered);
        }
        if (allMode) {
            setSelectedMessageForFiltering(messageId);
        }
    };

    return (
        <div className="mt-5">
            <div>Messages</div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="input-group w-50">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search for messages by ID, sender, recipient, message, etc."
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </div>
            </div>

            <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                    <thead className="thead-dark">
                        <tr>
                            {allMode ? <th></th> : null}
                            <th>ID</th>
                            <th>Order ID</th>
                            <th>Message</th>
                            <th>Sender</th>
                            <th>Recipient</th>
                            <th>Created At</th>
                            <th>Updated At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredMessages.map((message) => (
                            <tr key={message.id} onClick={() => setSelectedMessageId(message.id)}>
                                {allMode ? (
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={message.id === selectedMessageId}
                                            onChange={() => {
                                                if (message.id === selectedMessageId) {
                                                    handleRowClick(null);
                                                } else {
                                                    handleRowClick(message.id);
                                                }
                                            }}
                                        />
                                    </td>) : null}
                                <td>{message.id}</td>
                                <td>{message.order_id}</td>
                                <td style={{
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}>
                                    {message.message}
                                </td>
                                <td>{message.sender}</td>
                                <td>{message.recipient}</td>
                                <td>{new Date(message.created_at).toLocaleString()}</td>
                                <td>{new Date(message.updated_at).toLocaleString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Messages;
